var _path, _rect, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMp3Dark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 6V24H2V0H14L20 6ZM3 23H19V7H13V1H3V23ZM14 6H18.5L14 1.5V6Z",
    fill: "#F4F4F4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 13,
    width: 20,
    height: 9,
    rx: 1,
    fill: "#C600C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 17.5L8 15H9V20H8V17L7 19H6L5 17V20H4L4.0127 15H5L6.5 17.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 16L17.5 17C18.4569 17.1153 19.0033 17.7001 19.001 18.46C18.9973 19.5474 17.9533 20.0026 17 20C16.3212 19.9981 15.5538 19.8366 15.001 19.4268L15.5 18.5C15.8762 18.803 16.4308 18.9984 17 19C17.6907 19.002 17.7964 18.9129 17.7979 18.46C17.7979 17.8378 16.5736 18.0016 16 18V17L17.5 16H15V15.0117L19 15V16Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9834 15C13.1321 15.0039 14 15.4497 14 16.998C14 18.498 12.99 19.0133 11.9434 19.0098H10.9805V19.9883L10 19.9922L10.0127 15H11.9834ZM10.9805 17.998H12C12.7098 18.0004 12.9983 17.6351 13 16.998C13.0017 16.361 12.7097 16.0003 12 15.998H11L10.9805 17.998Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMp3Dark);
export default __webpack_public_path__ + "static/media/mp3_dark.6b7f61c73ad606b48b293568414b523e.svg";
export { ForwardRef as ReactComponent };